module.exports = __webpack_public_path__ + "static/media/no-image.a0613aaa.svg";